// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---src-pages-404-js": function componentSrcPages404Js() {
    return import("./../../src/pages/404.js"
    /* webpackChunkName: "component---src-pages-404-js" */
    );
  },
  "component---src-pages-about-js": function componentSrcPagesAboutJs() {
    return import("./../../src/pages/about.js"
    /* webpackChunkName: "component---src-pages-about-js" */
    );
  },
  "component---src-pages-ecommerce-web-development-js": function componentSrcPagesEcommerceWebDevelopmentJs() {
    return import("./../../src/pages/ecommerce-web-development.js"
    /* webpackChunkName: "component---src-pages-ecommerce-web-development-js" */
    );
  },
  "component---src-pages-frequently-asked-questions-js": function componentSrcPagesFrequentlyAskedQuestionsJs() {
    return import("./../../src/pages/frequently-asked-questions.js"
    /* webpackChunkName: "component---src-pages-frequently-asked-questions-js" */
    );
  },
  "component---src-pages-index-js": function componentSrcPagesIndexJs() {
    return import("./../../src/pages/index.js"
    /* webpackChunkName: "component---src-pages-index-js" */
    );
  },
  "component---src-pages-partnerships-js": function componentSrcPagesPartnershipsJs() {
    return import("./../../src/pages/partnerships.js"
    /* webpackChunkName: "component---src-pages-partnerships-js" */
    );
  },
  "component---src-pages-portfolio-js": function componentSrcPagesPortfolioJs() {
    return import("./../../src/pages/portfolio.js"
    /* webpackChunkName: "component---src-pages-portfolio-js" */
    );
  },
  "component---src-pages-web-development-js": function componentSrcPagesWebDevelopmentJs() {
    return import("./../../src/pages/web-development.js"
    /* webpackChunkName: "component---src-pages-web-development-js" */
    );
  },
  "component---src-templates-portfolio-js": function componentSrcTemplatesPortfolioJs() {
    return import("./../../src/templates/portfolio.js"
    /* webpackChunkName: "component---src-templates-portfolio-js" */
    );
  },
  "component---src-templates-tech-js": function componentSrcTemplatesTechJs() {
    return import("./../../src/templates/tech.js"
    /* webpackChunkName: "component---src-templates-tech-js" */
    );
  }
};